<template>
  <footer
    class="text-tiny-normal flex w-full flex-col gap-[12px] border-t border-[#f1f1f1] bg-[--color-neutral-white] px-[24px] py-[18px] lg:min-h-[51px] lg:flex-row lg:flex-wrap lg:items-start lg:gap-x-[24px]"
  >
    <p class="min-w-0 max-w-full text-[--color-neutral-neutral] lg:shrink-0">
      {{ t('layout.etsy_disclaimer') }}
    </p>
    <div class="flex max-w-full shrink-0 flex-wrap items-center gap-[12px] text-[--color-neutral-light]">
      <a
        href="https://members.erank.com/plans"
        class="rounded-sm underline transition-colors hover:text-[--color-neutral-neutral] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[--color-brand-forrest-green] focus-visible:ring-offset-2"
        @click="trackFooterLink('Plans')"
      >
        {{ t('layout.more_info.plans') }}
      </a>
      <a
        href="https://erank.com/affiliate"
        target="_blank"
        rel="noopener noreferrer"
        class="rounded-sm underline transition-colors hover:text-[--color-neutral-neutral] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[--color-brand-forrest-green] focus-visible:ring-offset-2"
        @click="trackFooterLink('Affiliates')"
      >
        {{ t('layout.more_info.affiliates') }}
      </a>
      <a
        href="https://erank.com/legal/privacy-policy"
        class="rounded-sm underline transition-colors hover:text-[--color-neutral-neutral] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[--color-brand-forrest-green] focus-visible:ring-offset-2"
        @click="trackFooterLink('Privacy')"
      >
        {{ t('layout.footer.privacy') }}
      </a>
      <a
        href="https://erank.com/legal/terms-of-service"
        class="rounded-sm underline transition-colors hover:text-[--color-neutral-neutral] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[--color-brand-forrest-green] focus-visible:ring-offset-2"
        @click="trackFooterLink('Terms')"
      >
        {{ t('layout.footer.terms') }}
      </a>
      <span>© eRank</span>
    </div>
  </footer>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';

import { mixPanelEvents } from '@/common/constants';
import { track } from '@/helpers/analytics/mixpanel';

const { t } = useI18n();

const trackFooterLink = (name: string) => {
  track(mixPanelEvents.CLICKED_FOOTER_LINK, {
    'Link Name': name,
    'Erank Version': 3,
  }, { transport: 'sendBeacon' });
};
</script>
